module.exports = __webpack_public_path__ + "28b67065/img/document.e2130c6b.svg";